<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 1.33337H5.33333C4.59695 1.33337 4 1.93033 4 2.66671V13.3334C4 14.0698 4.59695 14.6667 5.33333 14.6667H10.6667C11.403 14.6667 12 14.0698 12 13.3334V2.66671C12 1.93033 11.403 1.33337 10.6667 1.33337Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
